export default {"src":"/_next/static/media/eu-expansion-hero.6b258012.svg","height":150,"width":330,"blurWidth":0,"blurHeight":0};